module.exports = __webpack_public_path__ + "img/video.b6975b7f.png";